const admin = [
  { 
    label: "Dashboard", 
    icon: "icon ni ni-growth", 
    url: "/admin/dashboard" 
  },
  
  
  {
    label: "Product Categories",
    icon: "icon ni ni-grid-alt",
    url: "/admin/categories",
  },
  {
    label: "Products",
    icon: "icon ni ni-block-over",
    url: "/admin/products",
  }, {
    label: "Stock Management",
    icon: "icon ni ni-view-x3",
    url: "/admin/stock",
  },
  {
    label: "Orders",
    icon: "icon ni ni-table-view",
    url: "/admin/orders",
  },
];

export default admin;
